<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.50267 4.06201C3.80695 3.93597 4.15719 4.00564 4.39007 4.23852L8.15714 8.00559L11.9242 4.23852C12.2422 3.92052 12.7578 3.92052 13.0758 4.23852L16.8429 8.00559L20.6099 4.23852C20.8428 4.00564 21.1931 3.93597 21.4973 4.06201C21.8016 4.18804 22 4.48496 22 4.81431V16.7572C22 17.2069 21.6354 17.5715 21.1857 17.5715H3.81429C3.36457 17.5715 3 17.2069 3 16.7572V4.81431C3 4.48496 3.19839 4.18804 3.50267 4.06201ZM4.62857 6.78017V15.9429H20.3714V6.78017L17.4186 9.73295C17.1006 10.051 16.5851 10.051 16.2671 9.73295L12.5 5.96588L8.73293 9.73295C8.41493 10.051 7.89935 10.051 7.58136 9.73295L4.62857 6.78017ZM3.81429 20.8286C3.36457 20.8286 3 20.464 3 20.0143C3 19.5646 3.36457 19.2 3.81429 19.2H21.1857C21.6354 19.2 22 19.5646 22 20.0143C22 20.464 21.6354 20.8286 21.1857 20.8286H3.81429Z"
      fill="url(#paint0_linear_5364_4499)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_4499"
        x1="3"
        y1="4"
        x2="19.7761"
        y2="22.8118"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
